/**
 * 📃 The possible statuses of the invoices
 */
export enum InvoiceStatus {
  Paid,
  Pending,
  Rollover
}

/**
 * 📄 Model representing a single subscription invoice
 */
export default class Invoice {
  constructor(
    public amountDue: number,
    public total: number,
    public tax: number,
    public paid: boolean,
    public attempted: boolean,
    public created: number,
    public periodStart: number,
    public periodEnd: number,
    public paidTime: number,
    public url: string,
    public pdf: string
  ) { }

  // 🚦 The status of the current invoice
  public get status(): InvoiceStatus {
    if (this.amountDue <= 0 && this.total >= 0) {
      return InvoiceStatus.Rollover
    }
    if (!this.paid) {
      return InvoiceStatus.Pending;
    } else {
      return InvoiceStatus.Paid;
    }
  }

  // 🚩 Flag for whether the status of the invoice is Rollover
  public get isRolledOver(): boolean {
    return this.status == InvoiceStatus.Rollover;
  }

  // 🤡 Dummy data used for testing purposes
  public static examples = [
    new Invoice(1254, 1250, 0.03, true, true, 1494529010, 1498529010, 1594529010, 1494529010, "https://oneclick.fi/", "https://oneclick.fi/"),
    new Invoice(0, 12, 2.03, true, true, 1494529010, 1497529010, 1498529010, 1494529010, "https://oneclick.fi/", "https://oneclick.fi/"),
  ]
}